import React from "react";

function StudentPasskn() {
  return (
    <div className="body_style">
      <div className="letters-color-section">
        <h3 className="letters-color-section-main-heading">ವಿದ್ಯಾರ್ಥಿ ಪಾಸ್</h3>
        <div className="letters-color-section-sub-heading-section">
          <span className="new-blue">ಹೊಸ</span>
          <h5 className="letters-color-section-sub-heading">
            ವಿದ್ಯಾರ್ಥಿ ಪಾಸ್‌ಗಾಗಿ ಅರ್ಜಿ ಸಲ್ಲಿಸಲು ದಯವಿಟ್ಟು ಸೇವಾ ಸಿಂಧು ಪೋರ್ಟಲ್‌ಗೆ
            ಭೇಟಿ ನೀಡಿ
          </h5>
        </div>
        <div className="letters-color-section-sub-heading-section">
          <h5 className="letters-color-section-sub-heading">
            ಸೇವಾ ಸಿಂಧು ಪೋರ್ಟಲ್‌ಗೆ ಭೇಟಿ ನೀಡಲು
          </h5>
          <span>ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ</span>
        </div>
      </div>
    </div>
  );
}

export default StudentPasskn;
